import { render, staticRenderFns } from "./productAdvantageRow.vue?vue&type=template&id=7f43fb6e&scoped=true&"
import script from "./productAdvantageRow.vue?vue&type=script&lang=js&"
export * from "./productAdvantageRow.vue?vue&type=script&lang=js&"
import style0 from "./productAdvantageRow.vue?vue&type=style&index=0&id=7f43fb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f43fb6e",
  null
  
)

export default component.exports